<template>
  <div class="grid pb-0">
    <div class="grid-body list-booking-group">
      <div class="p-3">
        <!-- start -->
        <b-row>
          <b-col md="7">
            <div class="search-box">
              <v-btn @click="searchByCode()" outlined class="search-icon-left">
              <svg focusable="false" height="24px" viewBox="0 0 24 24" width="24px" xmlns="http://www.w3.org/2000/svg">
                  <path d="M20.49,19l-5.73-5.73C15.53,12.2,16,10.91,16,9.5C16,5.91,13.09,3,9.5,3S3,5.91,3,9.5C3,13.09,5.91,16,9.5,16 c1.41,0,2.7-0.47,3.77-1.24L19,20.49L20.49,19z M5,9.5C5,7.01,7.01,5,9.5,5S14,7.01,14,9.5S11.99,14,9.5,14S5,11.99,5,9.5z"></path><path d="M0,0h24v24H0V0z" fill="none"></path>
              </svg>
              </v-btn>
              <input v-model="bookingCodeSearch" @keyup.enter="searchByCode()" type="text" :placeholder="$t('_BOOKING.ENTER_BOOKING_CODE_OTA')" />
              <v-btn outlined @click="openPopup()" class="search-icon-right">
              <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"><path d="M3 17v2h6v-2H3zM3 5v2h10V5H3zm10 16v-2h8v-2h-8v-2h-2v6h2zM7 9v2H3v2h4v2h2V9H7zm14 4v-2H11v2h10zm-6-4h2V7h4V5h-4V3h-2v6z"></path></svg>
              </v-btn>
            </div>
            <!-- start -->
            <div class="overlay-search" @click="openPopup()" v-if="isShowPopup"></div>
            <div class="popup-search p-3" v-if="isShowPopup">
                <b-row>
                    <b-col md="6">
                        <label>
                            {{
                                $t("_BOOKING.SEARCH_CONDITION")
                            }}
                        </label>
                        <v-select outlined dense item-text="text" item-value="value"
                            :items="listSearchCondition" v-model="selectedSearchCondition" class="w-100" />
                    </b-col>
                    <b-col md="6"
                        v-if="selectedSearchCondition === 'BOOKING_CODE' || selectedSearchCondition === 'BOOKING_CODE_OTA'">
                        <label>{{
                            $t("_BOOKING.SEARCH_BOOKING_CODE")
                        }}</label>
                        <v-text-field v-model="paging.code" dense outlined class="w-100"></v-text-field>
                    </b-col>
                    <b-col md="6" v-if="selectedSearchCondition === null ||
                        selectedSearchCondition === 'BOOKING_DATE' ||
                        selectedSearchCondition === 'CHECKIN_DATE' ||
                        selectedSearchCondition === 'CHECKOUT_DATE'
                        ">
                        <label>{{
                            $t("_BOOKING.SEARCH_DATE")
                        }}</label>
                        <div class="d-flex justify-content-between">
                            <date-picker :confirm-text="$t('CONFIRM')" :clearable="false"
                            :type="selectedSearchCondition === 'BOOKING_DATE' ? 'datetime' : 'date'"
                                :popup-class="'popup-calendar-desktop-detailhotel'" v-model="dateRange"
                                :lang="languageDate" 
                                :format="selectedSearchCondition === 'BOOKING_DATE' ? 'DD/MM/YYYY HH:mm:ss' : 'DD/MM/YYYY'" :editable="false" :shortcuts=[]
                                range placeholder="Select date range">
                            </date-picker>
                        </div>
                    </b-col>
                    <b-col md="6" v-if="selectedSearchCondition === 'STAY_DATE'">
                        <label>{{
                        $t("_BOOKING.SEARCH_BY.STAYING_DATE")
                        }}</label>
                        <div class="d-flex justify-content-between">
                        <date-picker :confirm-text="$t('CONFIRM')" :clearable="false"
                            :popup-class="'popup-calendar-desktop-detailhotel'" v-model="stayDate" :lang="languageDate"
                            :format="'DD/MM/YYYY'" :editable="false" :shortcuts=[] :range="false" placeholder="Select date">
                        </date-picker>
                        </div>
                    </b-col>
                </b-row>
                <b-row>
                    <b-col md="6" class="pt-0 pr-0">
                        <label>{{
                            $t("BOOKING_CHANNEL")
                        }}</label>
                        <v-autocomplete dense outlined item-text="text" item-value="value"
                            :items="listSelectOTA" v-model="selectedOTA" chips multiple ref="selectedOTA">
                            <template v-slot:prepend-item>
                                <p class="mx-3 mt-1"> <a class="text-primary"
                                    @click="selectedOTA = [...new Set(selectedOTA.concat($refs['selectedOTA'].filteredItems.map(e => e.value)))]">{{ $t('SELECT_ALL') }}</a> | <a
                                    class="text-primary" @click="selectedOTA = []">{{ $t('UN_SELECT_ALL') }}</a>
                                </p>
                            </template>

                            <template v-slot:selection="{ item, index }">
                                <v-chip color="primary" v-if="index === 0" v-bind="item.attrs" :input-value="item.selected" close
                                    @click:close="remove(index, selectedOTA)" @click="item.select">
                                    <p class="mb-0 text-truncate" style="max-width: 150px">{{ item.text }}</p>
                                </v-chip>
                                <span v-if="index === 1" class="grey--text caption">(+{{ selectedOTA.length - 1 }})</span>
                            </template>
                            <template slot="no-data">
                                    <div class="no-data">{{ $t("NO_DATA") }}</div>
                            </template>
                        </v-autocomplete>
                    </b-col>
                    <b-col md="6" class="py-0">
                      <label>{{ $t("BOOKING_HOTEL") }}</label>
                      <v-autocomplete chips dense multiple outlined item-text="text" item-value="value" :items="listSelectHotel"
                        v-model="selectedHotel" ref="selectedHotel">
                        <template v-slot:prepend-item>
                          <p class="mx-3 mt-1"> <a class="text-primary"
                              @click="selectedHotel = [...new Set(selectedHotel.concat($refs['selectedHotel'].filteredItems.map(e => e.value)))]">{{ $t('SELECT_ALL') }}</a> | <a
                              class="text-primary" @click="selectedHotel = []">{{ $t('UN_SELECT_ALL') }}</a>
                          </p>
                        </template>

                        <template v-slot:selection="{ item, index }">
                          <v-chip color="primary" v-if="index === 0" v-bind="item.attrs" :input-value="item.selected" close
                            @click:close="remove(index, selectedHotel)" @click="item.select">
                            <p class="mb-0 text-truncate" style="max-width: 150px">{{ item.text }}</p>
                          </v-chip>
                          <span v-if="index === 1" class="grey--text caption">(+{{ selectedHotel.length - 1 }})</span>
                        </template>
                        <template slot="no-data">
                          <div class="no-data">{{ $t("NO_DATA") }}</div>
                        </template>
                      </v-autocomplete>
                    </b-col>
                </b-row>
                <b-row>
                  <b-col md="6" class="pt-0 pr-0">
                        <label>{{ $t("_BOOKING_TRANSACTION.BOOKING_STATUS") }}</label>
                        <v-autocomplete dense outlined item-text="text" item-value="value"
                            :items="listBookingStatus" v-model="selectedBookingStatus" chips multiple  ref="selectedBookingStatus">
                            <template v-slot:prepend-item>
                                <p class="mx-3 mt-1"> <a class="text-primary"
                                    @click="selectedBookingStatus = [...new Set(selectedBookingStatus.concat($refs['selectedBookingStatus'].filteredItems.map(e => e.value)))]">{{ $t('SELECT_ALL') }}</a> | <a
                                    class="text-primary" @click="selectedBookingStatus = []">{{ $t('UN_SELECT_ALL') }}</a>
                                </p>
                            </template>

                            <template v-slot:selection="{ item, index }">
                                <v-chip color="primary" v-if="index === 0" v-bind="item.attrs" :input-value="item.selected" close
                                    @click:close="remove(index, selectedBookingStatus)" @click="item.select">
                                    <p class="mb-0 text-truncate" style="max-width: 150px">{{ item.text }}</p>
                                </v-chip>
                                <span v-if="index === 1" class="grey--text caption">(+{{ selectedBookingStatus.length - 1 }})</span>
                            </template>
                            <template slot="no-data">
                                    <div class="no-data">{{ $t("NO_DATA") }}</div>
                            </template>
                        </v-autocomplete>
                    </b-col>
                    <b-col md="6" class="py-0">
                      <label>
                        {{ $t("_BOOKING.SEARCH_PMS_STATUS") }}
                      </label>
                      <v-autocomplete outlined dense item-text="text" item-value="value" :items="listSearchPmsStatus"
                        v-model="selectedSearchPmsStatus">
                      </v-autocomplete>
                    </b-col>
                </b-row>
                <b-row>
                  <b-col md="6" class="pt-0 pr-0">
                    <label>
                      {{ $t("_BOOKING.SEARCH_PMS_CODE") }}
                    </label>
                    <v-autocomplete chips dense multiple outlined item-text="text" item-value="value" :items="listSearchPmsCode"
                      v-model="selectedSearchPmsCode" ref="selectedSearchPmsCode">
                      <template v-slot:prepend-item>
                        <p class="mx-3 mt-1"> <a class="text-primary"
                            @click="selectedSearchPmsCode = [...new Set(selectedSearchPmsCode.concat($refs['selectedSearchPmsCode'].filteredItems.map(e => e.value)))]">{{ $t('SELECT_ALL') }}</a> | <a
                            class="text-primary" @click="selectedSearchPmsCode = []">{{ $t('UN_SELECT_ALL') }}</a>
                        </p>
                      </template>

                      <template v-slot:selection="{ item, index }">
                        <v-chip color="primary" v-if="index === 0" v-bind="item.attrs" :input-value="item.selected" close
                          @click:close="remove(index, selectedSearchPmsCode)" @click="item.select">
                          <span>{{ item.text }}</span>
                        </v-chip>
                        <span v-if="index === 1" class="grey--text caption">(+{{ selectedSearchPmsCode.length - 1 }})</span>
                      </template>
                      <template slot="no-data">
                        <div class="no-data">{{ $t("NO_DATA") }}</div>
                      </template>
                    </v-autocomplete>
                  </b-col>
                    <b-col md="6" class="pt-0">
                        <label>{{
                            $t("SEARCH_BY_BOOKER")
                        }}</label>
                        <v-text-field v-model="customerName" dense outlined></v-text-field>
                    </b-col>
                </b-row>
                <b-row>
                  <b-col md="6" class="pt-0 pr-0">
                    <label>
                      {{ $t("_BOOKING.UNMAP_BOOKING.UNMAP_BOOKING_TITLE") }}
                    </label>
                    <v-autocomplete outlined dense item-text="text" item-value="value" :items="listBookingUnmap"
                      v-model="selectedBookingUnmap">
                    </v-autocomplete>
                  </b-col>
                </b-row>
                <!-- End coding -->
                <div class="d-flex justify-end align-items-end flex-wrap py-0 mb-2">
                    <div class="mr-3 reset">
                        <v-btn class="pl-5 pr-5" @click="reset()">
                            <v-icon size="20" left>
                                mdi-refresh
                            </v-icon>
                            {{ $t("_BOOKING.RESET") }}
                        </v-btn>
                    </div>
                    <div class="mr-3">
                        <v-btn color="primary" class="pl-5 pr-5" @click="getAll(true)">
                            <v-icon size="20" left>
                                search
                            </v-icon>
                            {{ $t("_BOOKING.SEARCH") }}
                        </v-btn>
                    </div>
                </div>
            </div>
            <!-- end -->
          </b-col>
          <b-col>
            <div class="d-flex px-3">
              <v-btn outlined @click="exportBooking" class="ml-auto export-excel">
                <v-icon size="20" left>
                  save_alt
                </v-icon>
                {{ $t("_BOOKING.EXPORT") }}
              </v-btn>
              <v-btn color="success" v-if="selectedRepost.length > 0" @click.stop="openPopupMultiReSync(selectedRepost)"
                class="ml-3">
                <i class="icon-sync fs-18 mr-2"></i> 
                {{ $t('RE_SYNC')
                }}</v-btn>
            </div>
          </b-col>
        </b-row>
      </div>
      <!-- button scroll -->
      <div ref="containerCondition" class="container-condition py-4 pt-0">
        <div class="d-flex align-items-center">
          <button
                v-if="isShowArrow"
                class="left round"
                @click="scrollLeft"
              >
              <v-icon>mdi-chevron-left</v-icon>
          </button>
            <div ref="scrollContainer" class="overflow-auto scroll-container">
                <div v-if="conditionSearch === 'BOOKING_DATE'" class="d-inline-flex gap-3">
                  <label class="" :title="conditionSearch === 'BOOKING_DATE' && conditionDateRange[0] ? formatDate(conditionSearch, conditionDateRange) : ''">
                    <div class="border p-1 pl-2 pr-2 mr-3 rounded" :class="conditionSearch === 'BOOKING_DATE' && conditionDateRange[0] && !isClear ? 'active-condition' : ''">
                      {{ this.$t("_BOOKING.SEARCH_BY.BOOKING_DATE") }} {{ conditionSearch === 'BOOKING_DATE' && conditionDateRange[0] && !isClear ? ': '+ formatDate(conditionSearch, conditionDateRange) : ''  }}
                    </div>
                    </label>
                </div>

                <div v-if="conditionSearch === 'CHECKIN_DATE'" class="d-inline-flex gap-3">
                  <label class="" :title="conditionSearch === 'CHECKIN_DATE' && conditionDateRange[0] ? formatDate(conditionSearch, conditionDateRange) : ''">
                    <div class="border p-1 pl-2 pr-2 mr-3 rounded" :class="conditionSearch === 'CHECKIN_DATE' && conditionDateRange[0] && !isClear ? 'active-condition' : ''">
                      {{ this.$t("_BOOKING.SEARCH_BY.CHECKIN_DATE") }} {{ conditionSearch === 'CHECKIN_DATE' && conditionDateRange[0] && !isClear ? ': '+ formatDate(conditionSearch, conditionDateRange) : ''  }}
                    </div>
                    </label>
                </div>

                <div v-if="conditionSearch === 'CHECKOUT_DATE'" class="d-inline-flex gap-3">
                  <label class="" :title="conditionSearch === 'CHECKOUT_DATE' && conditionDateRange[0] ? formatDate(conditionSearch, conditionDateRange) : ''">
                    <div class="border p-1 pl-2 pr-2 mr-3 rounded" :class="conditionSearch === 'CHECKOUT_DATE' && conditionDateRange[0] && !isClear ? 'active-condition' : ''">
                      {{ this.$t("_BOOKING.SEARCH_BY.CHECKOUT_DATE") }} {{ conditionSearch === 'CHECKOUT_DATE' && conditionDateRange[0] && !isClear ? ': '+ formatDate(conditionSearch, conditionDateRange) : ''  }}
                    </div>
                    </label>
                </div>

                <div v-if="conditionSearch === 'STAY_DATE'" class="d-inline-flex gap-3">
                  <label class="" :title="conditionStayDate ? formatDate(conditionSearch, conditionStayDate) : ''">
                    <div class="border p-1 pl-2 pr-2 mr-3 rounded" :class="conditionSearch === 'STAY_DATE' && conditionStayDate && !isClear ? 'active-condition' : ''">
                        {{ this.$t("_BOOKING.SEARCH_BY.STAYING_DATE") }} {{ conditionSearch === 'STAY_DATE' && conditionStayDate && !isClear ? ': '+ formatDate(conditionSearch, conditionStayDate) : ''  }}
                    </div>
                    </label>
                </div>

                <div v-if="listNameOTA && listNameOTA.length > 0" class="d-inline-flex gap-3">
                    <label :title="listNameOTA.join('\n')">
                    <div class="border p-1 pl-2 pr-2 mr-3 rounded" :class="listNameOTA.length > 0 && !isClear ? 'active-condition' : ''">
                        {{ $t("BOOKING_CHANNEL") }} {{ listNameOTA.length > 0 && !isClear ? (listNameOTA.length > 1 ? ': ' + listNameOTA[0]+'...' : ': ' + listNameOTA[0]) : ''  }}
                    </div>		
                    </label>
                </div>

                <div v-if="listNameHotel && listNameHotel.length > 0" class="d-inline-flex gap-3">
                    <label :title="listNameHotel.join('\n')">
                    <div class="border p-1 pl-2 pr-2 mr-3 rounded" :class="listNameHotel.length > 0 && !isClear ? 'active-condition' : ''">
                        {{ $t("BOOKING_HOTEL") }} {{ listNameHotel.length > 0 && !isClear ? (listNameHotel.length > 1 ? ': ' + listNameHotel[0]+'...' : ': ' + listNameHotel[0]) : ''  }}
                    </div>		
                    </label>
                </div>

                <div v-if="listNameBKStatus && listNameBKStatus.length > 0" class="d-inline-flex gap-3">
                    <label :title="listNameBKStatus.join('\n')">
                    <div class="border p-1 pl-2 pr-2 mr-3 rounded" :class="listNameBKStatus.length > 0 && !isClear ? 'active-condition' : ''">
                        {{ $t("_BOOKING_TRANSACTION.BOOKING_STATUS") }} {{ listNameBKStatus.length > 0 && !isClear ? (listNameBKStatus.length > 1 ? ': ' + listNameBKStatus[0]+'...' : ': ' + listNameBKStatus[0]) : ''  }}
                    </div>		
                    </label>
                </div>

                <div v-if="listNamePmsStt && listNamePmsStt.text" class="d-inline-flex gap-3">
                  <label :title="listNamePmsStt ? listNamePmsStt.text : ''">
                    <div class="border p-1 pl-2 pr-2 mr-3 rounded" :class="!isClear ? 'active-condition' : ''">
                      {{ $t("_BOOKING.SEARCH_PMS_STATUS") }} {{ !isClear ? ': ' + listNamePmsStt.text : '' }}
                    </div>		
                  </label>
                </div>

                <div v-if="conditionCustomerName" class="d-inline-flex gap-3">
                    <label :title="conditionCustomerName">
                    <div class="border p-1 pl-2 pr-2 mr-3 rounded" :class="conditionCustomerName && !isClear ? 'active-condition' : ''">
                        {{  $t("SEARCH_BY_BOOKER") }} {{ conditionCustomerName && !isClear ? ': ' + conditionCustomerName : '' }}
                    </div>		
                    </label>
                </div>

                <div v-if="listNamePmsCode && listNamePmsCode.length > 0" class="d-inline-flex gap-3">
                    <label :title="listNamePmsCode.join('\n')">
                    <div class="border p-1 pl-2 pr-2 mr-3 rounded" :class="listNamePmsCode.length > 0 && !isClear ? 'active-condition' : ''">
                        {{ $t("_BOOKING.SEARCH_PMS_CODE") }} {{ listNamePmsCode.length > 0 && !isClear ? (listNamePmsCode.length > 1 ? ': ' + listNamePmsCode[0]+'...' : ': ' + listNamePmsCode[0]) : ''  }}
                    </div>
                    </label>
                </div>
                
                <div v-if="listNamePmsUnmap && listNamePmsUnmap.text" class="d-inline-flex gap-3">
                  <label :title="listNamePmsUnmap ? listNamePmsUnmap.text : ''">
                    <div class="border p-1 pl-2 pr-2 mr-3 rounded" :class="!isClear ? 'active-condition' : ''">
                      {{ $t("_BOOKING.UNMAP_BOOKING.UNMAP_BOOKING_TITLE") }} {{ !isClear ? ': ' + listNamePmsUnmap.text : '' }}
                    </div>		
                  </label>
                </div>
            </div>
            <button
                v-if="isShowArrow"
                class="right round"
                @click="scrollRight"
            >
                <v-icon>mdi-chevron-right</v-icon>
            </button>
        </div>
    </div>
    <!-- button scroll -->
      <v-progress-linear class="custom-progress" color="warning" indeterminate rounded height="3" v-if="isLoading"></v-progress-linear>
      <v-data-table 
        v-model="selectedRepost"
        :headers="headers"
        :items="dataTable"
        :single-select="false"
        item-key="bookingCode"
        show-select
        hide-default-footer
        :items-per-page="dataTable.length"
        :no-data-text="$t('NO_RECORDS')"
        :show-select="fnReSync ? true : false"
        v-if="!isLoading" class="table-booking">
        <!-- slot header -->
        <template v-slot:header.priceBeforeCommission="{ header }">
          {{ header.text }}
          <v-tooltip top>
            <template v-slot:activator="{ on, attrs }">
              <v-icon v-bind="attrs" v-on="on" class="fs-14">mdi-information</v-icon>
            </template>
            <div class="fs-13" style="max-width: 300px">{{ $t('COMMISSION_RATE_NOTE') }}</div>
          </v-tooltip>
        </template>
        <template v-slot:header.priceAfterCommission="{ header }">
          {{ header.text }}
          <v-tooltip top>
            <template v-slot:activator="{ on, attrs }">
              <v-icon v-bind="attrs" v-on="on" class="fs-14">mdi-information</v-icon>
            </template>
            <div class="fs-13" style="max-width: 300px">{{ $t('COMMISSION_RATE_NOTE') }}</div>
          </v-tooltip>
        </template>
        <template v-slot:item.index="{ item, index }">{{ paging.offset + index + 1 }}</template>
        <template v-slot:item.bookingCustomer="{ item }">
          <a class="app-link text-decoration-none" href="javascript:;"
            @click="goToBookingDetail(item.bookingCode)">
            {{
              item.bookingCustomer.name + ' ' + item.bookingCustomer.surname
            }}
          </a>
        </template>
        <template v-slot:item.otaBookingCode="{ item }">{{ item.otaBookingCode }}</template>
        <template v-slot:item.arrival="{ item }">
          <template v-if="item.arrival && item.departure">
            {{
              _formatDateTime(
                item.arrival,
                "YYYY-MM-DD",
                systemLang == 'vi' ? "DD/MM/YYYY" : "YYYY/MM/DD"
              ) +
              " - " +
              _formatDateTime(
                item.departure,
                "YYYY-MM-DD",
                systemLang == 'vi' ? "DD/MM/YYYY" : "YYYY/MM/DD"
              )
            }}
          </template>
          <template v-else>N/A</template>
        </template>
        <template v-slot:item.amount="{ item }">
          <strong>{{ formatCurrency(item.amount, item.currencyCode) }}</strong>
        </template>
        <template v-slot:item.bookingStatus="{ item }">
          <span :style="{ color: listBookingStatus.find(x => x.value == item.bookingStatus).color }">
            {{
              listBookingStatus.find(x => x.value == item.bookingStatus).text
            }}
          </span>
        </template>
        <template v-slot:item.bookingCode="{ item }">
          {{
            item.bookingCode
          }}
        </template>
        <template v-slot:item.ota="{ item }">
          {{ item.ota.nameVi }}
        </template>
        <template v-slot:item.hotel="{ item }">
          {{ item.hotel.nameVi }}
        </template>
        <template v-slot:item.timeZoneStr="{ item }">
          {{ findTimeZone(item.timeZoneStr) }}
        </template>
        <template v-slot:item.createdDate="{ item }">
          {{ formatDateTime(item.createdDate) }}
        </template>
        <template v-slot:item.paymentCollectType="{ item }">
          {{ item.paymentCollectType === 0 ? $t("_BOOKING_DETAIL.PROPERTY_COLLECT") : item.paymentCollectType === 1 ? $t("_BOOKING_DETAIL.OTA_CONTACT") : $t("_BOOKING_DETAIL.CHANNEL_COLLECT") }}
        </template>
        <template v-slot:item.commission="{ item }">
            <strong>{{ item.commission ? formatCurrency(item.commission, item.currencyCode) : 'N/A' }}</strong>
          </template>
          <template v-slot:item.priceAfterCommission="{ item }">
            <strong>{{item.priceAfterCommission ? formatCurrency(item.priceAfterCommission, item.currencyCode) : 'N/A'}}</strong>
          </template>
          <template v-slot:item.priceBeforeCommission="{ item }">
            <strong>{{item.priceBeforeCommission ? formatCurrency(item.priceBeforeCommission, item.currencyCode) : 'N/A' }}</strong>
          </template>
        <template v-slot:item.pmsCode="{ item }">
          <template v-if="item.pmsCode">
            <v-menu bottom left>
              <template v-slot:activator="{ on, attrs }">
                <v-btn depressed :color="item.channelStatus === 1 ? 'success' : ''" x-small v-bind="attrs"
                  v-on="on" class="rounded-sm  mr-1" outlined>
                  <i class="icon-more_vert fs-16 cursor font-weight-bold"></i>
                </v-btn>
              </template>

              <div class="d-flex bg-white p-2">
                <div class="mr-3">
                  <p v-if="item.channelStatus === 1" class="m-0 pr-3">
                    <span class="text-success">{{ $t('_DASHBOARD._HOTEL_STATUS_SYNC_PMS.RECEIVED') }}</span> <br>
                    <span class="fs-10">{{
                      formatDateTime(item.channelTime)
                    }}</span>
                  </p>
                  <p v-else class="m-0 pr-3">{{ $t('_DASHBOARD._HOTEL_STATUS_SYNC_PMS.NOT_RECEIVED') }}</p>
                </div>
                <div class="text-right">
                  <p class="mb-0">{{ item.pmsCode.split(',').map(e => $t(e)).join(", ") }}</p>
                  <v-btn color="success" v-if="fnReSync" x-small @click.stop="openPopupReSync(item)"><small>{{ $t('RE_SYNC')
                  }}</small></v-btn>
                </div>
              </div>
            </v-menu>
          </template>
        </template>
        <template v-slot:item.bitUnmap="{ item }">
          <p class="mb-0" v-if="item.bitUnmap == 0">{{  $t('_BOOKING.UNMAP_BOOKING.MAPPED') }}</p>
          <p class="mb-0" v-if="(item.bitUnmap & 1) !== 0">{{  $t('_BOOKING.UNMAP_BOOKING.UNMAP_RATE_PLAN') }}</p>
          <p class="mb-0" v-if="(item.bitUnmap & 2) !== 0">{{  $t('_BOOKING.UNMAP_BOOKING.UNMAP_ROOM_TYPE') }}</p>
        </template>
      </v-data-table>

      <v-row
          class="mt-2 mx-3"
          align="center"
          justify="center"
        >
          <span class="grey--text">{{  $t('ITEMS_PER_PAGE') }}</span>
          <v-menu offset-y>
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                dark
                text
                color="primary"
                class="ml-2"
                v-bind="attrs"
                v-on="on"
              >
                {{ paging.limit }}
                <v-icon>mdi-chevron-down</v-icon>
              </v-btn>
            </template>
            <v-list>
              <v-list-item
                v-for="(number, index) in itemsPerPageArray"
                :key="index"
                @click="paging.limit = number; getAll(true)"
              >
                <v-list-item-title>{{ number }}</v-list-item-title>
              </v-list-item>
            </v-list>
          </v-menu>

          <v-spacer></v-spacer>

          <paging v-if="paging && paging.total" :paging.sync="paging" @changePage="changePage" class="pr-3">
            <span slot="totalItems">{{ $t("TOTAL") }}:
              {{ $tc("_BOOKING.BOOKING", paging.total) }}</span>
          </paging>
        </v-row>
      
    </div>
    <confirm-dialog @deleteItem="reSync" :maxWidth="325" :persistent="true" ref="reSyncDialogComponent">
      <span slot="title">{{ $t("CONFIRM_RE_SYNC") }} booking: {{ bookingReSync ? bookingReSync.otaBookingCode :
        null }}</span>
    </confirm-dialog>
    <confirm-dialog @deleteItem="reSyncs" :maxWidth="325" :persistent="true" ref="reSyncsDialogComponent">
      <span slot="title">{{ $t("CONFIRM_RE_SYNC") }} booking</span>
    </confirm-dialog>
    <v-navigation-drawer
      v-model="showSidebar"
      absolute
      temporary
      right
      width="1000"
    >
      <booking-detail 
        v-if="showSidebar" 
        :code="code" 
        @close="() => { showSidebar = false }"
      ></booking-detail>
    </v-navigation-drawer>
  </div>
</template>

<script>
import DateRangePicker from 'vue2-daterange-picker';
import 'vue2-daterange-picker/dist/vue2-daterange-picker.css';
import Paging from "@/components/Utils/Paging.vue";
import { syncota } from "@/_services/SyncOTA/syncota.js";
import { chainService } from "@/_services/ChainManage/chain.service.js";
import {
  _alert,
  _formatCurrency,
  _formatDateTimeUTCToLocal
} from "@/_helpers/function.js";
import moment from "moment";
import FileSaver from "file-saver";
import DatePicker from 'vue2-datepicker';
import 'vue2-datepicker/index.css';
import ConfirmDialog from "@/components/Utils/ConfirmDialog.vue";
import BookingDetail from './BookingDetail.vue';

export default {
  components: {
    DateRangePicker,
    paging: Paging,
    "date-picker": DatePicker,
    "confirm-dialog": ConfirmDialog,
    BookingDetail
  },
  data() {
    return {
      showSidebar: false,
      code: null,
      locale_data: {
        format: 'YYYY-MM-DD',
        separator: ' - ',
        applyLabel: 'Apply',
        cancelLabel: 'Cancel',
        weekLabel: 'W',
        daysOfWeek: [this.$t("_DATE_RANGE.SUNDAY"), this.$t("_DATE_RANGE.MONDAY"), this.$t("_DATE_RANGE.TUESDAY"), this.$t("_DATE_RANGE.WEDNESDAY"), this.$t("_DATE_RANGE.THURSDAY"), this.$t("_DATE_RANGE.FRIDAY"), this.$t("_DATE_RANGE.SATURDAY")],
        monthNames: [this.$t("_DATE_RANGE.JAN"), this.$t("_DATE_RANGE.FEB"), this.$t("_DATE_RANGE.MAR"), this.$t("_DATE_RANGE.APR"), this.$t("_DATE_RANGE.MAY"), this.$t("_DATE_RANGE.JUN"), this.$t("_DATE_RANGE.JUL"), this.$t("_DATE_RANGE.AUG"), this.$t("_DATE_RANGE.SEP"), this.$t("_DATE_RANGE.OTC"), this.$t("_DATE_RANGE.NOV"), this.$t("_DATE_RANGE.DEC")],
        firstDay: 1
      },
      dateRange: [],
      stayDate: null,
      systemLang: this.$i18n.locale,
      isLoading: false,
      headers: [
        {
          text: this.$t("STT"),
          align: 'center',
          value: 'index',
          sortable: false
        },
        {
          text: this.$t("BOOKING_CUSTOMER_NAME"),
          value: "bookingCustomer",
        },
        {
          text: this.$t("BOOKING_CODE_OTA"),
          value: "otaBookingCode",
        },
        {
          text: this.$t("_BOOKING.TIME_STAY"),
          value: "arrival",
          class: "text-center"
        },
        {
          text: this.$t("_BOOKING.AMOUNT"),
          value: "amount",
          align: 'end',
        },
        {
          text: this.$t("_BOOKING.BOOKING_STATUS"),
          align: 'center',
          value: "bookingStatus",
        },
        {
          text: this.$t("_BOOKING.BOOKING_CODE"),
          class: "text-center",
          value: "bookingCode",
        },
        {
          text: this.$t("BOOKING_CHANNEL"),
          class: "text-center",
          value: "ota",
        },
        {
          text: this.$t("BOOKING_HOTEL"),
          class: "text-left",
          value: "hotel",
        },
        {
          text: this.$t("UTC"),
          class: "text-center",
          value: "timeZoneStr",
        },
        {
          text: this.$t("_BOOKING.BOOKING_DATE"),
          value: "createdDate",
          class: "text-center",
          align: 'end',
        },
        {
          text: this.$t('_BOOKING_DETAIL.PAYMENT_COLLECT'),
          value: "paymentCollectType",
          class: "text-center",
          align: 'center',
        },
        {
          text: this.$t('_BOOKING_DETAIL.BEFORE_COMMISSION'),
          value: "priceBeforeCommission",
          align: 'end',
        },
        {
          text: this.$t('_BOOKING_DETAIL.COMMISSION'),
          value: "commission",
          align: 'end',
        },
        {
          text: this.$t('_BOOKING_DETAIL.AFTER_COMMISSION'),
          value: "priceAfterCommission",
          align: 'end',
        },
        {
          text: this.$t("_DASHBOARD.SYNC_PMS"),
          value: "pmsCode",
          align: 'center',
          sortable: false
        },
        {
          text: this.$t("_BOOKING.UNMAP_BOOKING.UNMAP_BOOKING_TITLE"),
          value: "bitUnmap",
        },
      ],
      dataTable: [],
      selectedSearchCondition: 'BOOKING_DATE',
      listSearchCondition: [
        {
          value: "BOOKING_CODE",
          text: this.$t("_BOOKING.SEARCH_BY.BOOKING_CODE")
        },
        {
          value: "BOOKING_CODE_OTA",
          text: this.$t("BOOKING_CODE_OTA")
        },
        {
          value: "BOOKING_DATE",
          text: this.$t("_BOOKING.SEARCH_BY.BOOKING_DATE")
        },
        {
          value: "CHECKIN_DATE",
          text: this.$t("_BOOKING.SEARCH_BY.CHECKIN_DATE")
        },
        {
          value: "CHECKOUT_DATE",
          text: this.$t("_BOOKING.SEARCH_BY.CHECKOUT_DATE")
        },
        {
          value: "STAY_DATE",
          text: this.$t("_BOOKING.SEARCH_BY.STAYING_DATE")
        }
      ],
      selectedBookingStatus: [],
      listBookingStatus: [
        {
          value: 0,
          text: this.$t("_BOOKING.STATUS.AWAIT_PAYMENT"),
          color: "rgb(254, 209, 47)"
        },
        {
          value: 1,
          text: this.$t("_BOOKING.STATUS.CONFIRM"),
          color: "#0da313"
        },
        {
          value: 2,
          text: this.$t("_BOOKING.STATUS.CANCEL"),
          color: "#808080"
        },
        {
          value: 3,
          text: this.$t("_BOOKING.STATUS.VOID"),
          color: "#DC0000"
        },
        {
          value: 4,
          text: this.$t("_BOOKING.STATUS.IN_SERVICE"),
          color: "#262626"
        },
        {
          value: 5,
          text: this.$t("_BOOKING.STATUS.CLOSE"),
          color: "#262626"
        },
        {
          value: 6,
          text: this.$t("_BOOKING.STATUS.PAYMENT_FAILED"),
          color: "#ff0000"
        },
        {
          value: 7,
          text: this.$t("_BOOKING.STATUS.AWAIT_FULLY_PAYMENT"),
          color: "#fed12f"
        },
      ],
      listSelectOTA: [],
      listSelectHotel: [],
      selectedHotel: [],
      selectedOTA: [],
      paging: {
        total: 0,
        limit: 15,
        offset: 0,
        searchBy: 'BOOKING_DATE',
        otaId: null,
        hotelId: null,
        lang: this.$i18n.locale
      },
      customerName: null,
      bookingReSync: null,
      listSearchPmsStatus: [
        {
          value: null,
          text: this.$t("ALL")
        },
        {
          value: 1,
          text: this.$t("_DASHBOARD._HOTEL_STATUS_SYNC_PMS.RECEIVED")
        },
        {
          value: 0,
          text: this.$t("_DASHBOARD._HOTEL_STATUS_SYNC_PMS.NOT_RECEIVED")
        },
      ],
      listSearchPmsCode: [
        {
          value: 'ez_FOLIO',
          text: this.$t("ez_FOLIO")
        },
        {
          value: 'ez_CLOUDHOTEL',
          text: this.$t("ez_CLOUDHOTEL")
        },
        {
          value: '',
          text: this.$t("_DASHBOARD._HOTEL_STATUS_SYNC_PMS.UNSYNCHRONIZED")
        },
      ],
      selectedSearchPmsStatus: null,
      selectedSearchPmsCode: [],
      selectedRepost: [],
      bookingReSyncs: [],
      fnReSync: false,
      currentRoute: this.$route.path,
      isShowPopup: false,
      isScrollLeftDisabled: true,
      isScrollRightDisabled: false,
      conditionStayDate: null,
      bookingCodeSearch: '',
      isClear: false,
      listNameBKStatus: [],
      listNamePmsStt: [],
      listNameHotel: [],
      listNamePmsCode: [],
      conditionDateRange: [],
      conditionSearch: 'BOOKING_DATE',
      widthScroll: 0,
      widthContainer: 0,
      resizeObserver: null,
      isShowArrow: false,
      listNamePmsUnmap: [],
      selectedBookingUnmap: null,
      listBookingUnmap: [
        {
          value: null,
          text: this.$t("_BOOKING.UNMAP_BOOKING.ALL")
        },
        {
          value: 0,
          text: this.$t("_BOOKING.UNMAP_BOOKING.MAPPED")
        },
        {
          value: 1,
          text: this.$t("_BOOKING.UNMAP_BOOKING.UNMAP_RATE_PLAN")
        },
        {
          value: 2,
          text: this.$t("_BOOKING.UNMAP_BOOKING.UNMAP_ROOM_TYPE")
        },
        {
          value: 3,
          text: this.$t("_BOOKING.UNMAP_BOOKING.UNMAP_ROOMRATE")
        },
      ],
    };
  },
  watch: {
    selectedBookingStatus() {
      this.paging.status = this.selectedBookingStatus.length == 0 ? null : this.selectedBookingStatus;
    },
    selectedSearchCondition() {
      this.paging.searchBy = this.selectedSearchCondition;
    },
    selectedOTA() {
      this.paging.otaId = this.selectedOTA;
    },
    selectedHotel() {
      this.paging.hotelId = this.selectedHotel;
    },
    dateRange() {
      this.paging.from = this.dateRange[0];
      this.paging.to = this.dateRange[1];
    },
    showSidebar() {
      if(this.showSidebar == false) {
        history.pushState(null, '', `${this.currentRoute}`);
      }
    },
    widthScroll() {      
      if (this.widthScroll + 50 > this.widthContainer) {
          this.isShowArrow = true;
      } else {
          this.isShowArrow = false;
      }
    }
  },
  beforeDestroy() {
    if (this.resizeObserver) {
      this.resizeObserver.disconnect();
    }
  },
  computed: {
    numberSearch() {
      var num = 0
      if (this.customerName) {
        num += 1;
      }
      if (this.selectedSearchPmsCode.length > 0) {
        num += 1;
      }
      if (this.selectedSearchPmsStatus !== null) {
        num += 1;
      }
      if (this.selectedBookingStatus.length > 0) {
        num += 1;
      }
      if (this.selectedBookingUnmap !== null) {
        num += 1;
      }
      return num
    }
  },
  created() {
    let searchHistory = sessionStorage.getItem('searchHistory');
    if (searchHistory) {
      searchHistory = JSON.parse(searchHistory);
      this.selectedSearchCondition = searchHistory.selectedSearchCondition;
      this.dateRange = [new Date(searchHistory.dateRange[0]), new Date(searchHistory.dateRange[1])];
      this.stayDate = new Date(searchHistory.stayDate);
      this.selectedOTA = searchHistory.selectedOTA;
      this.selectedHotel = searchHistory.selectedHotel;
      this.selectedBookingStatus = searchHistory.selectedBookingStatus;
      this.selectedSearchPmsStatus = searchHistory.selectedSearchPmsStatus;
      this.selectedSearchPmsCode = searchHistory.selectedSearchPmsCode;
      this.customerName = searchHistory.customerName;
      this.paging = searchHistory.paging;
      this.paging.offset = 0;
      this.selectedBookingUnmap = searchHistory.selectedBookingUnmap;
      if (searchHistory.selectedBookingStatus.length == 0) {
        this.paging.status = null;
      }
    } else {
      const today = new Date();
      today.setHours(0);
      today.setMinutes(0);
      today.setSeconds(0);
      const day1 = new Date(moment().add(1, 'day'));
      day1.setHours(0);
      day1.setMinutes(0);
      day1.setSeconds(0);
      this.dateRange = [today,day1];
      this.stayDate = new Date(moment().format('YYYY-MM-DD'));
    }
  },
  mounted() {
    this.initialize();
  },
  methods: {
    disableSixMonths(date) {
      
      if (!this.dateRange) return false;

      const selected = new Date(this.dateRange[0]);
      const sixMonthsLater = new Date(selected);
      sixMonthsLater.setMonth(selected.getMonth() + 6);

      // Vô hiệu hóa các ngày sau 6 tháng từ ngày đã chọn
      return date > sixMonthsLater;
    },
    remove(index, array) {
      array.splice(index, 1);
      this.$forceUpdate();
    },
    openPopupReSync(item) {
      this.bookingReSync = item
      this.$refs.reSyncDialogComponent.open(item)
    },
    openPopupMultiReSync(item) {
      this.bookingReSyncs = item.map(e => e.bookingCode)
      this.$refs.reSyncsDialogComponent.open(this.bookingReSyncs)
    },
    reSync(item) {
      const body = {
        bookingCode: item.bookingCode
      };
      chainService.reSync(body).then(res => {
        _alert(res, this.$t(res.data), false);
      });
    },
    reSyncs(item) {
      const body = {
        bookingCodes: [...item]
      };
      chainService.reSyncs(body).then(res => {
        _alert(res, this.$t(res.data), false);
      });
    },
    _formatDateTimeUTCToLocal(value, inputFormat, outputFormat) {
      if (!value) {
        return "";
      }
      return _formatDateTimeUTCToLocal(value, inputFormat, outputFormat);
    },
    _formatDateTime(value, inputFormat, outputFormat) {
      if (!value) {
        return "";
      }
      return moment(value).format(outputFormat);
    },
    calcTotalAmount(bookingLines) {
      let amount = 0;
      bookingLines.forEach(x => {
        amount = amount + x.amountPax;
      });
      return _formatCurrency(amount);
    },
    async initialize() {
      const currentUser = JSON.parse(localStorage.getItem("currentUser")) || {};
      const userRole = currentUser.user.roles
        ? currentUser.user.roles.map(role => role.fnCode)
        : undefined;
      this.fnReSync = userRole.indexOf("CHAIN_BOOKING_REPOST") >= 0
      let body = {
        keyword: "",
        status: 1
      };
      await syncota.getAllOTAChain(body).then(res => {
        if (res.responseCode === 0) {
          res.data.forEach(x => {
            this.listSelectOTA.push({
              value: x.id,
              text: x.otaI18n.find(y => y.lang == this.defaultI18n).name
            });
            // this.selectedOTA = this.listSelectOTA.map(e => e.value);
          });
        } else {
          _alert(res, this.$t(res.data), false);
        }
      });

      let chain = {
        keyword: "",
        status: 1,
        limit: 1000,
        offset: 0
      };

      await chainService
        .get(chain)
        .then(res => {
          if (res.responseCode === 0) {
            res.data.forEach(x => {
              this.listSelectHotel.push({
                value: x.id,
                text: x.hotelI18n.find(y => y.lang == this.defaultI18n).name
              });
            });
            // this.selectedHotel = this.listSelectHotel.map(e => e.value);
        } else {
          _alert(res, this.$t(res.data), false);
        }
      });
      this.getAll();
    },
    formatCurrency: _formatCurrency,
    // Change page
    changePage(paging) {
      this.paging = paging;
      this.getAll();
    },
    reset() {
        this.selectedSearchCondition = 'BOOKING_DATE';
        const today = new Date();
        today.setHours(0);
        today.setMinutes(0);
        today.setSeconds(0);
        const day1 = new Date(moment().add(1, 'day'));
        day1.setHours(0);
        day1.setMinutes(0);
        day1.setSeconds(0);
        this.dateRange = [today,day1];
        this.selectedOTA = [];
        this.selectedBookingStatus = [];
        this.selectedSearchPmsCode = []
        this.selectedSearchPmsStatus = null;
        this.selectedHotel = [];
        this.customerName = null;
        this.selectedBookingUnmap = null;
    },
    // Get all booking
    getAll(isSearching) {
      this.bookingCodeSearch = '';
      this.mapValuesOTA();
      this.mapValuesBKStatus();
      this.mapValueHotel();
      this.mapValuesPmsStt();
      this.mapValuesPmsCode();
      this.mapValuesPmsUnmap();
      this.conditionStayDate = this.stayDate;
      this.conditionCustomerName = this.customerName;
      this.conditionDateRange = this.deepCopyArrayWithDates(this.dateRange);
      this.conditionSearch = this.selectedSearchCondition;
      this.isShowPopup = false;
      this.paging.searchBy = this.selectedSearchCondition;
      this.isClear = false;
    if (this.selectedSearchCondition === null || this.selectedSearchCondition === 'BOOKING_DATE' || this.selectedSearchCondition === 'CHECKIN_DATE' || this.selectedSearchCondition === 'CHECKOUT_DATE') {
      if (this.isSixMonthsOrLess(this.dateRange[0], this.dateRange[1]) === 1) {
        _alert(null, this.$t("PLEASE_SELECT_DATE_LESS_6_MONTH"));
        return
      }
    }
    if ((this.paging.searchBy === 'BOOKING_CODE_OTA' || this.paging.searchBy === 'BOOKING_CODE') && !this.paging.code) {
      this.paging.total = 0;
      this.dataTable = [];
      return
    }
      if (isSearching) this.paging.offset = 0;
      this.selectedRepost = [];
      this.isLoading = true;
      this.$session.set("ojbBooking", this.paging);
      const body = {
        limit: this.paging.limit,
        offset: this.paging.offset,
        lang: this.defaultI18n,
        searchBy: this.paging.searchBy,
        from: moment(this.paging.from).format('YYYY-MM-DDTHH:mm:ss'),
        to: moment(this.paging.to).format('YYYY-MM-DDTHH:mm:ss'),
        code: this.paging.code,
        status: this.paging.status,
        otaIds: (this.paging.otaId) ? this.paging.otaId : null,
        hotelIds: (this.paging.hotelId) ? this.paging.hotelId : null,
        customerName: this.customerName,
        channelStatus: this.selectedSearchPmsStatus,
        pmsCodes: this.selectedSearchPmsCode,
        stayDate: moment(this.stayDate).format('YYYY-MM-DD'),
        unmap: this.selectedBookingUnmap
      };

      chainService
        .getAllBooking(body)
        .then(res => {
          if (res.responseCode === 0) {
            this.paging.total = res.total;
            this.dataTable = res.data.map(x => ({ ...x, isSelectable: x.pmsCode ? true : false }));
          } else {
            _alert(res, this.$t(res.data), false);
          }
        })
        .finally(() => (this.isLoading = false));
        this.resizeObserver = new ResizeObserver(entries => {
            for (let entry of entries) {
                if (entry.target === this.$refs.scrollContainer) {
                this.widthScroll = entry.contentRect.width;
                } else if (entry.target === this.$refs.containerCondition) {
                this.widthContainer = entry.contentRect.width;
                }
            }
        });
        this.resizeObserver.observe(this.$refs.scrollContainer);
        this.resizeObserver.observe(this.$refs.containerCondition);
    },
    searchByCode() {
      this.conditionDateRange = [];
      this.listNameOTA = [];
      this.listNameHotel = [];
      this.listNameBKStatus = [];
      this.listNamePmsStt = null;
      this.listNamePmsCode = [];
      this.listNamePmsUnmap = null;
      this.isClear = true;
      this.paging.searchBy = 'BOOKING_CODE_OTA';      
      if (this.paging.searchBy === 'BOOKING_CODE_OTA' && !this.bookingCodeSearch) {
        this.paging.total = 0;
        this.dataTable = [];
        return
      }
      this.isLoading = true;
      this.$session.set("ojbBooking", this.paging);
      const body = {
        limit: this.paging.limit,
        offset: this.paging.offset,
        lang: this.defaultI18n,
        searchBy: this.paging.searchBy,
        from: moment(this.paging.from).format('YYYY-MM-DDTHH:mm:ss'),
        to: moment(this.paging.to).format('YYYY-MM-DDTHH:mm:ss'),
        code: this.bookingCodeSearch,
        status: [],
        otaIds: null,
        hotelIds: null,
        customerName: null,
        channelStatus: null,
        pmsCodes: [],
        stayDate: null
      };
      chainService
        .getAllBooking(body)
        .then(res => {
          if (res.responseCode === 0) {
            this.paging.total = res.total;
            this.dataTable = res.data.map(x => ({ ...x, isSelectable: x.pmsCode ? true : false }));
          } else {
            _alert(res, this.$t(res.data), false);
          }
        })
        .finally(() => (this.isLoading = false));
    },
    // Go to booking detail page
    goToBookingDetail(code) {
      this.code = code;
      const routeInfo = this.$router.resolve({ 
        name: "chainBookingDetail",
        params: { code: code } 
      });
      history.pushState(null, '', routeInfo.href);
      let searchHistory = {
        selectedSearchCondition: JSON.parse(JSON.stringify(this.selectedSearchCondition)),
        paging: JSON.parse(JSON.stringify(this.paging)),
        dateRange: JSON.parse(JSON.stringify(this.dateRange)),
        stayDate: JSON.parse(JSON.stringify(this.stayDate)),
        selectedOTA: JSON.parse(JSON.stringify(this.selectedOTA)),
        selectedHotel: JSON.parse(JSON.stringify(this.selectedHotel)),
        selectedBookingStatus: JSON.parse(JSON.stringify(this.selectedBookingStatus)),
        selectedSearchPmsStatus: JSON.parse(JSON.stringify(this.selectedSearchPmsStatus)),
        selectedSearchPmsCode: JSON.parse(JSON.stringify(this.selectedSearchPmsCode)),
        customerName: JSON.parse(JSON.stringify(this.customerName)),
        selectedBookingUnmap: JSON.parse(JSON.stringify(this.selectedBookingUnmap)),
      };
      sessionStorage.setItem('searchHistory', JSON.stringify(searchHistory));
      this.showSidebar = true;
    },
    // Export booking
    exportBooking() {
      this.isLoading = true;
      let param = {
        lang: this.defaultI18n,
        searchBy: this.paging.searchBy,
        from: this.paging.from,
        to: this.paging.to,
        code: this.paging.code,
        status: this.paging.status,
        otaIds: (this.paging.otaId) ? this.paging.otaId : null,
        hotelIds: (this.paging.hotelId) ? this.paging.hotelId : null,
        exportDate: moment(new Date()).format('YYYY-MM-DD_HH:mm:ss'),
        channelStatus: this.selectedSearchPmsStatus,
        pmsCodes: this.selectedSearchPmsCode,
        stayDate: moment(this.stayDate).format('YYYY-MM-DD'),
        unmap: this.selectedBookingUnmap
      };
      chainService
        .exportBooking(param)
        .then(res => {
          if (res.responseCode === 0) {
            const url = res.data;
            FileSaver.saveAs(url);
          } else {
            _alert(res, this.$t(res.data), false);
          }
        })
        .finally(() => (this.isLoading = false));
    },
    openPopup() {
      this.isShowPopup = !this.isShowPopup;
    },
    scrollLeft() {
      const container = this.$refs.scrollContainer;
      container.scrollBy({
          left: -200,
          behavior: "smooth",
      });
    },
    scrollRight() {
      const container = this.$refs.scrollContainer;
      container.scrollBy({
          left: 200,
          behavior: "smooth",
      });
    },
    
    formatDate(condition, dateRage) {            
      var dateStart = moment(dateRage[0], "YYYY-MM-DD");
      var dateEnd = moment(dateRage[1], "YYYY-MM-DD");
      if (condition === 'BOOKING_DATE') {
          return dateStart.format("DD/MM/YYYY HH:mm:ss") + ' ~ ' + dateEnd.format("DD/MM/YYYY HH:mm:ss");
      } else if (condition === 'STAY_DATE') {                
          return moment(dateRage, "DD/MM/YYYY").format("DD/MM/YYYY");
      } else {
          return dateStart.format("DD/MM/YYYY")+ ' ~ ' + dateEnd.format("DD/MM/YYYY");
      }
    },
    mapValuesOTA() { 
      this.listNameOTA = this.selectedOTA.map(id => {
          const matchedItem = this.listSelectOTA.find(item => item.value === id); 
          return matchedItem ? matchedItem.text : null; 
      }).filter(item => item !== null)
    },
    mapValuesBKStatus() { 
      this.listNameBKStatus = this.selectedBookingStatus.map(id => {
          const matchedItem = this.listBookingStatus.find(item => item.value === id); 
          return matchedItem ? matchedItem.text : null; 
      }).filter(item => item !== null)
    },
    mapValueHotel() {
      this.listNameHotel = this.selectedHotel.map(id => {
          const matchedItem = this.listSelectHotel.find(item => item.value === id); 
          return matchedItem ? matchedItem.text : null; 
      }).filter(item => item !== null)
    },
    mapValuesPmsStt() {
      this.listNamePmsStt = this.listSearchPmsStatus.find(item => item.value === this.selectedSearchPmsStatus); 
    },
    mapValuesPmsCode() {
      this.listNamePmsCode = this.selectedSearchPmsCode.map(id => {
          const matchedItem = this.listSearchPmsCode.find(item => item.value === id); 
          return matchedItem ? matchedItem.text : null; 
      })
    },
    mapValuesPmsUnmap() {
      this.listNamePmsUnmap = this.listBookingUnmap.find(item => item.value === this.selectedBookingUnmap); 
    },
    _moment: moment
  }
};
</script>

<style scoped>
.search-box {
  width: 100% !important;
}
.popup-search {
  width: 100% !important;
}
.container-condition {
  margin-top: -8px !important;
}
</style>